import { createStyles } from "@mantine/emotion";

export const useStylesFooter = createStyles((theme) => ({
  footer: {
    backgroundColor: theme.customBackgrounds.blackPrimary,
    color: theme.customColors.white,
  },
  footerLogo: {
    display: "inline-block",
    position: "relative",
    alignSelf: "flex-start",
    paddingRight: theme.spacing.footer.logo.paddingRight,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
    sup: {
      position: "absolute",
      // Align to the wordmark, which sits lower than the standalone B icon.
      top: theme.spacing.footer.logo.registeredMark.top,
      right: 0,
      color: theme.customColors.white,
      fontFamily: theme.fontFamily.secondary,
      fontSize: theme.spacing.footer.logo.registeredMark.fontSize,
      fontWeight: 600,
      lineHeight: 1,
    },
  },
  footerTop: {
    paddingTop: theme.spacing.footer.top.padding.top,
    paddingBottom: theme.spacing.footer.top.padding.bottom,
    borderBottom: theme.customColors.footerBorder,
    ".footer-title": {
      fontSize: theme.spacing.footer.top.title.fontSize,
      lineHeight: theme.spacing.footer.top.title.lineHeight,
      fontFamily: theme.headings.fontFamily.secondary,
      color: theme.customColors.white,
      paddingBottom: theme.spacing.footer.top.title.paddingBottom,
    },
    ".link-footer-center": {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: theme.spacing.footer.top.link.fontSize,
      paddingBottom: theme.spacing.footer.top.link.paddingBottom,
      color: theme.customColors.white,
      minWidth: theme.spacing.footer.top.link.minWidth.default,
      display: "block",
      position: "relative",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        minWidth: theme.spacing.footer.top.link.minWidth.tablet,
      },
      svg: {
        width: theme.spacing.footer.top.link.icon.width,
        height: theme.spacing.footer.top.link.icon.height,
        position: "absolute",
        right: "0",
      },
      "&:hover": {
        textDecoration: "underline",
      },
    },
    ".link-footer-menu": {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: theme.spacing.footer.top.menu.fontSize,
      color: theme.customColors.white,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    ".menu": {
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        marginLeft: "auto",
        marginRight: "auto",
      },
      div: {
        [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
          gap: theme.spacing.footer.top.menu.gap + " !important",
        },
      },
    },
  },
  footerCenter: {
    paddingBottom: theme.spacing.footer.center.padding.bottom,
    paddingTop: theme.spacing.footer.center.padding.top,
    borderBottom: theme.customColors.footerBorder,
    ".social-item": {
      paddingLeft: theme.spacing.footer.center.social.padding.left,
      paddingRight: theme.spacing.footer.center.social.padding.right,
      textDecoration: "none",
      span: {
        display: "inline-block",
        height: theme.spacing.footer.center.social.icon.size,
        position: "relative",
        width: theme.spacing.footer.center.social.icon.size,
        span: {
          backgroundColor: theme.customBackgrounds.white,
          borderRadius: "50%",
          height: `calc(100% - ${theme.spacing.footer.center.social.icon.border})`,
          left: "0",
          position: "absolute",
          top: "0",
          width: `calc(100% - ${theme.spacing.footer.center.social.icon.border})`,
          zIndex: "0",
        },
        svg: {
          fill: theme.customBackgrounds.blackPrimary,
          border: theme.customColors.footerSocialBorder,
          borderRadius: "50%",
          left: "-0.125em",
          position: "relative",
          top: "-0.125em",
          zIndex: "1",
        },
      },
    },
    ".link-footer-menu-second": {
      fontSize: theme.spacing.footer.center.menu.fontSize,
      color: theme.customColors.white,
      fontFamily: theme.headings.fontFamily.secondary,
      "&:after": {
        color: theme.customColors.white,
        content: '"|"',
        marginLeft: theme.spacing.footer.center.menu.separator.marginLeft,
        position: "relative",
        top: theme.spacing.footer.center.menu.separator.top,
      },
      "&:hover": {
        textDecoration: "underline",
      },
      "&:last-child": {
        "&:after": {
          content: "none",
        },
      },
    },
  },
  form: {
    ".success": {
      color: theme.customColors.green,
      fontSize: theme.spacing.footer.form.message.fontSize,
      display: "block",
      position: "absolute",
      bottom: theme.spacing.footer.form.message.bottom,
    },
    ".error": {
      fontSize: theme.spacing.footer.form.message.fontSize,
      color: theme.customColors.red,
      position: "absolute",
    },
    ".form-fields-wrap": {
      position: "relative",
    },
    ".input": {
      background: "none",
      border: theme.customColors.footerInputBorder,
      borderRadius: "4px",
      borderRight: "none",
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      color: theme.customColors.white,
      paddingLeft: theme.spacing.footer.form.input.padding.left,
      paddingRight: theme.spacing.footer.form.input.padding.right,
      maxWidth: theme.spacing.footer.form.input.maxWidth,
      outline: "none",
      fontSize: theme.spacing.footer.form.input.fontSize,
      lineHeight: theme.spacing.footer.form.input.lineHeight,
      fontFamily: theme.headings.fontFamily.light,
      boxSizing: "border-box",
      height: theme.spacing.footer.form.input.height,
    },
    ".submit": {
      background: "none",
      padding:
        theme.spacing.footer.form.submit.padding.left +
        " " +
        theme.spacing.footer.form.submit.padding.right,
      border: theme.customColors.footerInputBorder,
      borderRadius: "4px",
      borderTopLeftRadius: "0",
      borderBottomLeftRadius: "0",
      lineHeight: theme.spacing.footer.form.submit.lineHeight,
      cursor: "pointer",
      paddingTop: theme.spacing.footer.form.submit.padding.top,
      paddingBottom: theme.spacing.footer.form.submit.padding.bottom,
      svg: {
        fill: "#88938f",
        paddingLeft: "0",
        fontStyle: "normal",
      },

      "&:hover": {
        backgroundColor: theme.customBackgrounds.white,

        svg: {
          fill: theme.customColors.black,
        },
      },
    },
  },
  footerBottom: {
    paddingBottom: theme.spacing.footer.bottom.padding.bottom,
    paddingTop: theme.spacing.footer.bottom.padding.top,
    fontSize: theme.spacing.footer.bottom.fontSize,
    fontFamily: theme.headings.fontFamily.secondary,
  },
}));
